import React from "react";

function About() {
  return (
    <>
      <h1>About this app</h1>
      <p>App to search Github users</p>
      <p>Version 1.0.0</p>
    </>
  );
}

export default About;
